import { Picker } from './MouseObjectInteraction';
import { DrawableObject, PickingSceneRenderer } from '../renderer';
import { Engine } from '../Engine';
import { Camera } from '../camera';

export class DefaultPicker implements Picker {
  private pickingRenderer: PickingSceneRenderer;

  constructor(private engine: Engine) {
    this.pickingRenderer = new PickingSceneRenderer();
    this.pickingRenderer.init(engine.ctx);
  }
  pick(camera: Camera, x: number, y: number): DrawableObject | undefined {
    return this.pickingRenderer.pick(this.engine.activeScene!, camera, x, y);
  }
}
